<div class="page-container">
  <div class="flex items-center justify-between">
    <h1 class="main-heading">Duty pullout list</h1>
    <app-navpath />
  </div>
  <section class="content-container">
    <app-data-form
      [dataFields]="form"
      (updateFields_child)="updateFields()"
      (clickSearch)="search($event)"
    />
    <div class="mt-4 flex w-fit gap-1">
      <button
        class="shorter-btn save-btn"
        *ngIf="tableEntries.length > 0"
        (click)="update()"
        [disabled]="lockBtn"
      >
        <fa-icon [icon]="faSave" class="mr-1" />Update
      </button>
      <button
        class="shorter-btn print-btn"
        (click)="print()"
        [disabled]="lockBtn"
      >
        <fa-icon [icon]="faPrint" class="mr-1" />Print
      </button>
      <button
        class="shorter-btn clear-btn"
        *ngIf="tableEntries.length > 0"
        (click)="this.tableEntries = []"
      >
        <fa-icon [icon]="faTrash" class="mr-1" />Clear
      </button>
    </div>
  </section>
  <section class="content-container" *ngIf="tableEntries.length > 0">
    <app-data-table
      [tableHeaders]="tableHeaders"
      [tableEntries]="tableEntries"
      [pagination]="false"
    ></app-data-table>
  </section>
</div>
